import { render, staticRenderFns } from "./TalkPanel.vue?vue&type=template&id=3592721a&scoped=true"
import script from "./TalkPanel.vue?vue&type=script&lang=js"
export * from "./TalkPanel.vue?vue&type=script&lang=js"
import style0 from "./TalkPanel.vue?vue&type=style&index=0&id=3592721a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3592721a",
  null
  
)

export default component.exports